<template>
  <el-card :body-style="bodyStyle" :shadow="shadow" class="ec-card">
    <div v-if="title || $slots.header" slot="header" class="ec-card-header">
      <slot name="header">
        <span class="ec-card-title">{{ title }}</span>
      </slot>
    </div>
    <slot />
    <div v-if="$slots.footer" class="ec-card-footer">
      <slot name="footer" />
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'EcCard',
  props: {
    title: { type: String, default: '' },
    shadow: { type: String, default: 'hover' },
    bodyStyle: { type: Object, default: () => ({}) },
  },
}
</script>

<style scoped>
.ec-card-title {
  font-size: 0.9375rem;
  font-weight: 600;
}
.ec-card-footer {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--ec-border-color, #e9ecef);
}
</style>
